import { render, staticRenderFns } from "./musicCategory.vue?vue&type=template&id=12a2c6e6&scoped=true"
import script from "./musicCategory.vue?vue&type=script&lang=js"
export * from "./musicCategory.vue?vue&type=script&lang=js"
import style0 from "./musicCategory.vue?vue&type=style&index=0&id=12a2c6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a2c6e6",
  null
  
)

export default component.exports